import { render, staticRenderFns } from "./HistorialContratos.vue?vue&type=template&id=6884c802"
import script from "./HistorialContratos.vue?vue&type=script&lang=js"
export * from "./HistorialContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports